<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout row pa-4 style="width: 100%;">
    <v-flex md10>
      <l-map ref="theMap" :style="{width: '100%', height: mapData.height }" :zoom="mapData.zoomLevel" :center="mapData.center"
        @mousemove="onMouseMove" @mousedown="onMouseDown" @mouseup="onMouseUp" @keydown="onKeyDown" @keyup="onKeyUp"
      >
        <l-tile-layer :url="mapData.url" :attribution="mapData.attribution"></l-tile-layer>
      </l-map>
    </v-flex>
    <v-flex md2 ml-1>
      <v-layout column>
        <v-flex md12>
          <v-text-field ref="sigsQueryString" v-model="queryString" :placeholder="'LABEL_SIQS_SEARCHBOX' | translate" hide-details
            @input="onQueryInput"
          >
          </v-text-field>
        </v-flex>
        <v-flex>
          <v-progress-linear class="ma-0 mb-2" :indeterminate="isLoading"></v-progress-linear>
        </v-flex>
        <v-flex>
          <v-card class="ma-1">
            <v-card-title>{{ 'LABEL_SIQS_SEARCHRESULT' | translate }}</v-card-title>
            <v-card-text>
              <v-list :style="{overflow: 'auto', height: containerHeight}">
                <v-list-tile v-for="entry in searchResult" key="entry.id" @click="onSelectSearchItem(entry.id)">
                  <v-list-tile-content >
                    <v-list-tile-title v-html="entry.title"></v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
  import Vue from 'vue';
  import { latLng, DomUtil } from 'leaflet';
  import { LMap, LTileLayer } from 'vue2-leaflet';

  export default {
    name: "SearchItemGeoSelector",
    components: { LMap, LTileLayer },
    props: [ 'refFilterId', 'currentData', 'eventUpdateGeoSelection', 'containerHeight' ],
    watch: {
    },
    computed: {
      isLoading() {
        return this.requestState.state !== null;
      },
    },
    data() {
      return {
        queryString: '',
        searchResult: [],
        requestState: { state: null },
        mapData: {
          drawing: false,
          zoomLevel: 10,
          center: latLng(51.449133, 7.181006),
          height: '',
          url: 'https://{s}.tile.openstreetmap.de/{z}/{x}/{y}.png',
          attribution: '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors',
          circle: null,
        },
      };
    },
    methods: {
      onKeyDown (event) {
        Vue.prototype.$api.debug("onkeydown", {event: event });
        if (event.originalEvent.code === 'ControlLeft' || event.originalEvent.code === 'ControlRight') {
          DomUtil.addClass(this.$refs.theMap.mapObject._container, 'crosshair-cursor');
        }
      },
      onKeyUp (event) {
        Vue.prototype.$api.debug("onkeyup", {event: event });
        if (event.originalEvent.code === 'ControlLeft' || event.originalEvent.code === 'ControlRight') {
          DomUtil.removeClass(this.$refs.theMap.mapObject._container, 'crosshair-cursor');
        }
      },
      onMouseDown (event) {
        Vue.prototype.$api.debug("onMouseDown", {event: event });
        if (event.originalEvent.ctrlKey == true) {
          this.mapData.drawing = true;
          this.$refs.theMap.mapObject.dragging.disable();
          this.createCircle(event.latlng, 1);
        }
      },
      onMouseUp (event) {
        Vue.prototype.$api.debug("onMouseUp", {event: event });
        if (this.mapData.drawing == true) {
          this.mapData.drawing = false;
          this.$refs.theMap.mapObject.dragging.enable();
        }
      },
      onMouseMove (event) {
        if (!this.mapData.drawing || this.mapData.circle == null) {
          return;
        }

        let distance = this.mapData.circle.getLatLng().distanceTo(event.latlng);

        Vue.prototype.$api.debug("onMouseMove", {event: event, distance: distance});
        this.mapData.circle.setRadius(distance);

      },
      onResize () {
        if (this.$props.containerHeight) {
          this.mapData.height = this.$props.containerHeight + 'px';
          return;
        }
        const view = Vue.prototype.$api.viewport();
        const footerHeight = 35;
        const headerHeight = 100;
        const titleHeightOfMask = 95;
        let h2 = view.height - footerHeight - headerHeight - titleHeightOfMask ;
        this.mapData.height = h2 + 'px';
      },
      createCircle(coords, radius) {
        const cmp = this;
        if (this.mapData.circle != null) {
          this.$refs.theMap.mapObject.removeLayer(this.mapData.circle);
          this.mapData.circle = null;
        }
        this.mapData.circle = L.circle(coords, { radius: radius })
        .on({
          mousedown: function() {
            Vue.prototype.$api.debug('Circle mousedown');
            cmp.mapData.drawing = true;
            cmp.$refs.theMap.mapObject.dragging.disable();
          },
          mouseup: function () {
            Vue.prototype.$api.debug('Circle mouseup');

            cmp.mapData.drawing = false;
            cmp.$refs.theMap.mapObject.dragging.enable();
            cmp.submitCircle();
          }
        })
        .bindTooltip(function (c) {
          Vue.prototype.$api.debug("Tootip radius " + c.getRadius());
          return Vue.prototype.$api.formatLocaleNumber('f0', c.getRadius() / 1000) + " km";
        }, { className: 'radiustooltip', sticky: true})
        .addTo(this.$refs.theMap.mapObject);
      },
      submitCircle() {
        let ll = this.mapData.circle.getLatLng();
        Vue.prototype.$eventHub.$emit('SearchMaskItemUpdateData', this.$props.refFilterId, { 
          latitude: Vue.prototype.$api.formatLocaleNumber('f5', ll.lat),
          longitude: Vue.prototype.$api.formatLocaleNumber('f5', ll.lng),
          radius: Vue.prototype.$api.formatLocaleNumber('f0', this.mapData.circle.getRadius() / 1000)
      });
      },
      onQueryInput(event) {
        Vue.prototype.$api.debug("onInput", {event: event});
        const cmp = this;

        if (!event || event.lenhth < 4) {
          this.searchResult = [];
          return;
        }
        Vue.prototype.$api.searchOsmCities (event, this.requestState, function (data) {
          cmp.searchResult = data;
        });
      },
      onSelectSearchItem (event) {
        Vue.prototype.$api.debug("onSelectSearchItem", {event: event});
        const index = this.searchResult.findIndex(function (item, index) { return item.id === event; });
        if (index > -1) {
          this.$refs.theMap.setCenter(latLng(this.searchResult[index].lat, this.searchResult[index].lon));
        }
      },
    },
    created() {
      Vue.prototype.$api.debug('SearchItemGeoSelector created');
      window.addEventListener("resize", this.onResize);
    },
    destroyed() {
      Vue.prototype.$api.debug('SearchItemGeoSelector destroyed');
      window.removeEventListener("resize", this.onResize);
    },
    mounted() {
      const cmp = this;
      Vue.prototype.$api.debug('SearchItemGeoSelector mounted', this.$props.currentData);
      if (typeof this.$props.currentData === 'object') {
        if (this.$props.currentData.latitude && this.$props.currentData.longitude && this.$props.currentData.radius) {
          const coords = latLng(Vue.prototype.$api.parseLocaleNumber(this.$props.currentData.latitude), Vue.prototype.$api.parseLocaleNumber(this.$props.currentData.longitude));
          const radius = Vue.prototype.$api.parseLocaleNumber(this.$props.currentData.radius) * 1000;
          this.createCircle(coords, radius);
          this.$refs.theMap.setCenter(coords);
        }
      }
      window.dispatchEvent(new Event('resize'));

      this.$nextTick(function () {
        cmp.$refs.theMap.mapObject._container.focus() } );
    }
  }
</script>

<style>
.crosshair-cursor {
  cursor: crosshair !important;
}
.radiustooltip {
  color: black;
  background-color: rgb(243, 243, 243);
}
.radiustooltip::before {
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/module/mask/SearchItemGeoSelector.vue